import { parseAgrTicker, toRawTicker, isAgrTicker, parentTickerOf } from "../../Common/agrTicker";

export { parseAgrTicker, toRawTicker, isAgrTicker, parentTickerOf };

export function isAgrPolicy(entity: { isLinkedToAggregator?: boolean; ticker?: string }): boolean {
  return (
    entity.isLinkedToAggregator === true ||
    (typeof entity.ticker === "string" && isAgrTicker(entity.ticker))
  );
}
